import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FAQ_DATA = [
  {
    question: "Who is Derek Fee?",
    answer: "Derek Fee is an Irish crime thriller author known for creating two popular detective series: The Belfast Murders, featuring Detective Inspector Wilson, and The Galway Murders, following DI Fiona Madden. With over twenty published novels, he is one of Ireland's most prolific crime fiction writers."
  },
  {
    question: "What are the Belfast Murders books about?",
    answer: "The Belfast Murders is a twelve-book detective series set in Belfast, Northern Ireland. The series follows Detective Inspector Wilson and his team as they investigate crimes involving corruption, political intrigue, organized crime, and murder. The series begins with 'Nothing but Memories' and takes readers deep into the criminal underworld of Belfast."
  },
  {
    question: "What are the Galway Murders books about?",
    answer: "The Galway Murders is a nine-book Irish detective series set in Connemara and Galway. The series follows DI Fiona Madden and Sergeant Sean Tracy as they solve crimes in the beautiful but treacherous landscape of Ireland's west coast. Starting with 'Connemara Girl,' the series combines atmospheric settings with intricate crime plots."
  },
  {
    question: "What order should I read Derek Fee's books?",
    answer: "For The Belfast Murders, start with 'Nothing but Memories' and read in publication order through 'Mortal Blow' (12 books). For The Galway Murders, begin with 'Connemara Girl' and read through 'Murder in Rosmuc' (9 books). Derek Fee also has standalone novels including 'Monsignor's Son,' 'The Marlboro Man,' 'Saudi Takedown,' and others that can be read in any order."
  },
  {
    question: "Where can I buy Derek Fee's books?",
    answer: "Derek Fee's books are available on Amazon as both eBooks and paperbacks. Visit his Amazon author page at amazon.com/stores/Derek-Fee to browse his complete catalogue of Irish crime thrillers, detective novels, and standalone thrillers."
  },
  {
    question: "What genre does Derek Fee write?",
    answer: "Derek Fee writes primarily in the crime thriller genre. His novels span multiple sub-genres including police procedural, political thriller, action thriller, and supernatural mystery. All his books feature strong detective characters, intricate plots, and compelling Irish settings ranging from urban Belfast to rural Connemara."
  },
  {
    question: "Are Derek Fee's books set in Ireland?",
    answer: "Yes, most of Derek Fee's novels are set in Ireland. The Belfast Murders series is set in Belfast and Northern Ireland, while The Galway Murders series takes place in Galway, Connemara, and the west coast of Ireland. His standalone novels feature various settings including Ireland, Saudi Arabia, and other international locations."
  },
  {
    question: "What is Derek Fee's latest book?",
    answer: "Derek Fee's latest release is 'Murder in Rosmuc,' the ninth book in The Galway Murders series. Set in the tranquil landscapes of Connemara, DI Fiona Madden investigates the suspicious drowning of a local fish farm manager, uncovering a web of intrigue involving corruption and criminality beneath Connemara's serene beauty."
  }
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="max-w-3xl">
          <p className="text-rose-700 uppercase tracking-[0.3em] text-sm font-bold">
            Common Questions
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mt-3 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-zinc-400 mt-4 leading-relaxed">
            Everything you need to know about Derek Fee's Irish crime thriller novels and detective series.
          </p>

          <Accordion type="single" collapsible className="mt-10 space-y-2">
            {FAQ_DATA.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-white/5 bg-zinc-900/30 px-6"
              >
                <AccordionTrigger className="text-white text-left font-display text-base py-5 hover:text-rose-500 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-sm leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
